// 20 predefined colors for categories
export const AVAILABLE_COLORS = [
    '#3b82f6', // Blue
    '#10b981', // Green
    '#f59e0b', // Amber
    '#8b5cf6', // Purple
    '#06b6d4', // Cyan
    '#ec4899', // Pink
    '#ef4444', // Red
    '#f97316', // Orange
    '#84cc16', // Lime
    '#14b8a6', // Teal
    '#6366f1', // Indigo
    '#a855f7', // Violet
    '#f43f5e', // Rose
    '#eab308', // Yellow
    '#22c55e', // Emerald
    '#0ea5e9', // Sky
    '#d946ef', // Fuchsia
    '#fb923c', // Light Orange
    '#4ade80', // Light Green
    '#818cf8'  // Light Indigo
];
